import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { Logo } from '../Layout/Logo';
import styles from './BaseModalHeader.module.scss';
import { BaseModalContext } from './BaseModalContext';

interface BaseModalHeaderProps {
    children?: React.ReactNode;
    showDefaultLayout?: boolean;
    showLogo?: boolean;
    showCloseButton?: boolean;
    title?: string;
    onClose?: () => void;
    className?: string;
}

export const BaseModalHeader: React.FC<BaseModalHeaderProps> = ({
    children,
    showDefaultLayout = true,
    showLogo = true,
    showCloseButton = true,
    title,
    onClose,
    className
}) => {
    // Get onClose from context if not provided directly
    const context = useContext(BaseModalContext);
    const handleClose = onClose || context?.onClose;

    // If children provided and not using default layout, render custom content
    if (children && !showDefaultLayout) {
        return (
            <header className={`${styles.modalHeader} ${className || ''}`}>
                {children}
            </header>
        );
    }

    // Default layout (matching the current layout header)
    return (
        <header className={`${styles.modalHeader} ${className || ''}`}>
            <div className={styles.headerLeft}>
                {showLogo && <Logo className={styles.logo} />}
                {title && <h1 className={styles.title}>{title}</h1>}
                {children && <div className={styles.additionalContent}>{children}</div>}
            </div>
            
            {showCloseButton && handleClose && (
                <button 
                    className={styles.closeButton}
                    onClick={handleClose}
                    aria-label="Close modal"
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            )}
        </header>
    );
};

export default BaseModalHeader;
